<!-- Backdrop overlay -->
<div
  class="fixed inset-0 bg-slate-900/40 backdrop-blur-md z-50 flex items-center justify-center p-4 transition-opacity duration-300"
  *ngIf="!isCloseModal">
  <!-- Modal Container -->
  <div
    class="bg-white/95 dark:bg-slate-900/95 w-full max-w-5xl max-h-[95vh] rounded-[24px] shadow-[0_20px_60px_-15px_rgba(0,0,0,0.3)] border border-white/50 dark:border-slate-800/50 flex flex-col overflow-hidden backdrop-blur-xl animate-fade-in-up">
    <!-- Modal Header -->
    <div
      class="flex-none px-4 md:px-8 py-4 md:py-5 border-b border-slate-200/50 dark:border-slate-800/50 flex justify-between items-center bg-transparent gap-4">
      <div class="flex items-center gap-4">
        <div class="relative group">
          <div class="absolute -inset-1 bg-yellow-500/50 rounded-full opacity-70 transition duration-500"></div>
          <button type="button" (click)="openPicturePreview()"
            class="relative block w-14 h-14 md:w-16 md:h-16 rounded-full border-2 border-white dark:border-slate-800 overflow-hidden bg-slate-100 dark:bg-slate-700 cursor-pointer focus:outline-none focus:ring-2 focus:ring-amber-300"
            [title]="pictureUrl && !isPictureBroken ? 'คลิกเพื่อดูรูปใหญ่' : 'ไม่พบรูปโปรไฟล์'">
            <img *ngIf="pictureUrl && !isPictureBroken" [src]="pictureUrl"
              [alt]="memberProfile?.cityParkingUserProfileResponse?.fullName || 'LINE'"
              (error)="onPictureError()"
              class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
            <span *ngIf="!pictureUrl || isPictureBroken"
              class="material-icons text-2xl text-slate-400 dark:text-slate-500 absolute inset-0 flex items-center justify-center">broken_image</span>
            <div *ngIf="pictureUrl && !isPictureBroken"
              class="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-colors flex items-center justify-center">
              <span class="material-icons text-white text-xl opacity-0 group-hover:opacity-100 transition-opacity drop-shadow-lg">zoom_in</span>
            </div>
          </button>
          <div [ngClass]="{
              'bg-emerald-500 shadow-emerald-500/50':
                memberProfile?.cityParkingUserProfileResponse?.userStautsId ===
                2,
              'bg-rose-500 shadow-rose-500/50':
                memberProfile?.cityParkingUserProfileResponse?.userStautsId !==
                2,
            }"
            class="absolute bottom-0.5 right-0.5 w-4 h-4 rounded-full border-2 border-white dark:border-slate-800 shadow-sm pointer-events-none"
            [title]="
              memberProfile?.cityParkingUserProfileResponse?.userStautsId === 2
                ? 'Active'
                : 'Inactive'
            "></div>
        </div>
        <div>
          <h2
            class="text-xl md:text-2xl font-black text-slate-800 dark:text-white tracking-tight leading-tight uppercase flex items-center gap-3">
            {{
            memberProfile?.cityParkingUserProfileResponse?.fullName ||
            "สมาชิกใหม่"
            }}
            <!-- Toggle Switch next to user name -->
            <label *ngIf="memberProfile?.cityParkingUserProfileResponse"
              class="relative inline-flex items-center cursor-pointer group/header-toggle">
              <input type="checkbox" [checked]="
                  memberProfile?.cityParkingUserProfileResponse
                    ?.userStautsId === 2
                " (change)="toggleUserStatus($event)" class="sr-only peer" />
              <div
                class="w-10 h-5.5 bg-slate-200 dark:bg-slate-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-[18px] rtl:peer-checked:after:-translate-x-[18px] peer-checked:after:border-white after:content-[''] after:absolute after:top-[3px] after:start-[3px] after:bg-white after:rounded-full after:h-[16px] after:w-[16px] after:transition-all peer-checked:bg-amber-500 shadow-inner group-hover/header-toggle:ring-4 group-hover/header-toggle:ring-amber-500/10">
              </div>
            </label>
          </h2>
          <p class="text-sm text-slate-500 dark:text-slate-400 mt-0.5 font-medium">
            ID: #[{{
            memberProfile?.cityParkingUserProfileResponse?.id || "--"
            }}] |
            {{
            memberProfile?.cityParkingUserProfileResponse?.phone ||
            "ไม่พบเบอร์โทร"
            }}
          </p>
        </div>
      </div>

      <button (click)="closeModal()"
        class="w-10 h-10 flex items-center justify-center rounded-full bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 transition-colors shadow-sm">
        <span class="material-icons-outlined text-xl">close</span>
      </button>
    </div>

    <!-- Modal Body -->
    <div
      class="flex-1 overflow-y-auto px-4 md:px-8 py-4 md:py-8 bg-slate-50/30 dark:bg-slate-900/30 relative custom-scrollbar">
      <!-- Content Container -->
      <div
        class="bg-white dark:bg-slate-900 rounded-[20px] shadow-sm border border-slate-200/60 dark:border-slate-800 overflow-hidden">
        <!-- Top Stats Bar -->
        <div
          class="h-14 bg-slate-50/50 dark:bg-slate-800/30 border-b border-slate-200/60 dark:border-slate-800 px-4 md:px-6 flex justify-end items-center gap-3">
          <div
            class="flex items-center gap-2 px-3 py-1.5 bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-100 dark:border-slate-700 text-slate-600 dark:text-slate-300">
            <span class="material-icons-outlined text-[18px] text-amber-500">directions_car</span>
            <span class="text-xs font-bold">{{
              memberProfile?.cityParkingUserProfileResponse?.carCount || 0
              }}
              ทะเบียน</span>
          </div>
          <div
            class="flex items-center gap-2 px-3 py-1.5 bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-100 dark:border-slate-700 text-slate-600 dark:text-slate-300">
            <span class="material-icons-outlined text-[18px] text-slate-400">credit_card</span>
            <span class="text-xs font-bold">{{
              memberProfile?.cityParkingUserProfileResponse?.cardCount || 0
              }}
              บัตร</span>
          </div>
          <div
            class="flex items-center gap-2 px-3 py-1.5 bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-100 dark:border-slate-700 text-slate-600 dark:text-slate-300">
            <span class="material-icons-outlined text-[18px] text-emerald-500">payments</span>
            <span class="text-xs font-bold">{{
              memberProfile?.cityParkingUserProfileResponse?.balance || 0
              | number: "1.2-2"
              }}
              ฿</span>
          </div>
        </div>

        <!-- Modern Pill Tabs Navigation -->
        <div
          class="px-4 md:px-6 pt-4 md:pt-5 pb-4 md:pb-5 border-b border-slate-200/60 dark:border-slate-800 flex gap-2 overflow-x-auto scrollbar-hide">
          <button (click)="switchTab('info')"
            class="px-6 py-2.5 text-sm font-bold rounded-full transition-all whitespace-nowrap flex items-center gap-2"
            [ngClass]="
              activeTab === 'info'
                ? 'bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-400 shadow-sm'
                : 'bg-slate-100 dark:bg-slate-800 text-slate-500 hover:bg-slate-200 dark:hover:bg-slate-700'
            ">
            <span class="material-icons-outlined text-lg">person</span>
            ข้อมูลส่วนตัว
          </button>
          <button (click)="switchTab('license')"
            class="px-6 py-2.5 text-sm font-bold rounded-full transition-all whitespace-nowrap flex items-center gap-2"
            [ngClass]="
              activeTab === 'license'
                ? 'bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-400 shadow-sm'
                : 'bg-slate-100 dark:bg-slate-800 text-slate-500 hover:bg-slate-200 dark:hover:bg-slate-700'
            ">
            <span class="material-icons-outlined text-lg">directions_car</span>
            ทะเบียนรถ
          </button>
          <button (click)="switchTab('card')"
            class="px-6 py-2.5 text-sm font-bold rounded-full transition-all whitespace-nowrap flex items-center gap-2"
            [ngClass]="
              activeTab === 'card'
                ? 'bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-400 shadow-sm'
                : 'bg-slate-100 dark:bg-slate-800 text-slate-500 hover:bg-slate-200 dark:hover:bg-slate-700'
            ">
            <span class="material-icons-outlined text-lg">style</span>
            บัตรจอดรถ
          </button>
        </div>

        <!-- Content Area -->
        <div class="px-4 md:px-8 py-6 md:py-8 min-h-[400px] relative">
          <!-- Tab: Personal Info -->
          <div *ngIf="activeTab === 'info'" class="max-w-4xl space-y-6 animate-fade-in">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <!-- Left: Editable Fields -->
              <div class="space-y-6">
                <!-- Full Name -->
                <div class="grid grid-cols-1 gap-2 group">
                  <div class="flex justify-between items-center mb-1">
                    <label
                      class="text-[13px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">ชื่อ -
                      นามสกุล</label>
                    <div class="flex items-center gap-2">
                      <ng-container *ngIf="editingField === 'fullName'; else editNameBtn">
                        <button (click)="onSaveEdit('fullName')"
                          class="text-emerald-500 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 p-1 rounded-lg transition-all">
                          <span class="material-icons-outlined text-xl">check</span>
                        </button>
                        <button (click)="onCancelEdit()"
                          class="text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 p-1 rounded-lg transition-all">
                          <span class="material-icons-outlined text-xl">close</span>
                        </button>
                      </ng-container>
                      <ng-template #editNameBtn>
                        <!-- <button
                                                    (click)="onStartEdit('fullName', memberProfile?.cityParkingUserProfileResponse?.fullName)"
                                                    class="text-slate-400 hover:text-amber-500 transition-all p-1">
                                                    <span class="material-icons-outlined text-[18px]">edit</span>
                                                </button> -->
                      </ng-template>
                    </div>
                  </div>
                  <div class="relative w-full">
                    <input *ngIf="editingField === 'fullName'; else viewName" type="text" [(ngModel)]="tempEditValue"
                      class="w-full h-11 px-4 rounded-xl text-sm bg-white dark:bg-slate-800 border-2 border-amber-400 text-slate-900 dark:text-white outline-none ring-4 ring-amber-400/10" />
                    <ng-template #viewName>
                      <div
                        class="w-full h-11 px-4 rounded-xl text-sm bg-slate-50 dark:bg-slate-800/80 border border-transparent text-slate-900 dark:text-white flex items-center group-hover:bg-slate-100 dark:group-hover:bg-slate-700/50 transition-all">
                        {{
                        memberProfile?.cityParkingUserProfileResponse
                        ?.fullName
                        }}
                      </div>
                    </ng-template>
                    <p *ngIf="editingField === 'fullName' && validationError"
                      class="text-xs text-rose-500 mt-1 animate-pulse">
                      {{ validationError }}
                    </p>
                  </div>
                </div>

                <!-- Phone -->
                <div class="grid grid-cols-1 gap-2 group">
                  <div class="flex justify-between items-center mb-1">
                    <label
                      class="text-[13px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">เบอร์โทรศัพท์</label>
                    <div class="flex items-center gap-2">
                      <ng-container *ngIf="editingField === 'phone'; else editPhoneBtn">
                        <button (click)="onSaveEdit('phone')"
                          class="text-emerald-500 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 p-1 rounded-lg transition-all">
                          <span class="material-icons-outlined text-xl">check</span>
                        </button>
                        <button (click)="onCancelEdit()"
                          class="text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 p-1 rounded-lg transition-all">
                          <span class="material-icons-outlined text-xl">close</span>
                        </button>
                      </ng-container>
                      <ng-template #editPhoneBtn>
                        <button (click)="
                            onStartEdit(
                              'phone',
                              memberProfile?.cityParkingUserProfileResponse
                                ?.phone
                            )
                          " class="text-slate-400 hover:text-amber-500 transition-all p-1">
                          <span class="material-icons-outlined text-[18px]">edit</span>
                        </button>
                      </ng-template>
                    </div>
                  </div>
                  <div class="relative w-full">
                    <input *ngIf="editingField === 'phone'; else viewPhone" type="text" [(ngModel)]="tempEditValue"
                      maxlength="10"
                      class="w-full h-11 px-4 rounded-xl text-sm bg-white dark:bg-slate-800 border-2 border-amber-400 text-slate-900 dark:text-white outline-none ring-4 ring-amber-400/10 font-mono" />
                    <ng-template #viewPhone>
                      <div
                        class="w-full h-11 px-4 rounded-xl text-sm bg-slate-50 dark:bg-slate-800/80 border border-transparent text-slate-900 dark:text-white flex items-center group-hover:bg-slate-100 dark:group-hover:bg-slate-700/50 transition-all font-mono">
                        {{
                        memberProfile?.cityParkingUserProfileResponse?.phone
                        }}
                      </div>
                    </ng-template>
                    <p *ngIf="editingField === 'phone' && validationError"
                      class="text-xs text-rose-500 mt-1 animate-pulse">
                      {{ validationError }}
                    </p>
                  </div>
                </div>

                <!-- Email -->
                <div class="grid grid-cols-1 gap-2 group">
                  <div class="flex justify-between items-center mb-1">
                    <label
                      class="text-[13px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">อีเมล /
                      ติดต่อ</label>
                    <div class="flex items-center gap-2">
                      <ng-container *ngIf="editingField === 'email'; else editEmailBtn">
                        <button (click)="onSaveEdit('email')"
                          class="text-emerald-500 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 p-1 rounded-lg transition-all">
                          <span class="material-icons-outlined text-xl">check</span>
                        </button>
                        <button (click)="onCancelEdit()"
                          class="text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 p-1 rounded-lg transition-all">
                          <span class="material-icons-outlined text-xl">close</span>
                        </button>
                      </ng-container>
                      <ng-template #editEmailBtn>
                        <button (click)="
                            onStartEdit(
                              'email',
                              memberProfile?.cityParkingUserProfileResponse
                                ?.email
                            )
                          " class="text-slate-400 hover:text-amber-500 transition-all p-1">
                          <span class="material-icons-outlined text-[18px]">edit</span>
                        </button>
                      </ng-template>
                    </div>
                  </div>
                  <div class="relative w-full">
                    <input *ngIf="editingField === 'email'; else viewEmail" type="email" [(ngModel)]="tempEditValue"
                      class="w-full h-11 px-4 rounded-xl text-sm bg-white dark:bg-slate-800 border-2 border-amber-400 text-slate-900 dark:text-white outline-none ring-4 ring-amber-400/10" />
                    <ng-template #viewEmail>
                      <div
                        class="w-full h-11 px-4 rounded-xl text-sm bg-slate-50 dark:bg-slate-800/80 border border-transparent text-slate-900 dark:text-white flex items-center group-hover:bg-slate-100 dark:group-hover:bg-slate-700/50 transition-all break-all">
                        {{
                        memberProfile?.cityParkingUserProfileResponse
                        ?.email || "-"
                        }}
                      </div>
                    </ng-template>
                    <p *ngIf="editingField === 'email' && validationError"
                      class="text-xs text-rose-500 mt-1 animate-pulse">
                      {{ validationError }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Right: Metadata Cards -->
              <div class="space-y-4 flex flex-col justify-center items-start">
                <!-- Line ID -->
                <div
                  class="w-full bg-slate-50 dark:bg-slate-800/40 p-5 rounded-2xl border border-slate-100 dark:border-slate-800 flex justify-between items-center group transition-all hover:bg-white dark:hover:bg-slate-800 hover:shadow-sm">
                  <div class="flex items-center gap-4">
                    <div
                      class="w-10 h-10 rounded-xl bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 flex items-center justify-center">
                      <span class="material-icons-outlined text-xl">chat</span>
                    </div>
                    <div>
                      <label
                        class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest">Line
                        ID</label>
                      <span class="text-sm font-black text-slate-800 dark:text-slate-200">{{
                        memberProfile?.cityParkingUserProfileResponse?.lineId
                        }}</span>
                    </div>
                  </div>
                  <span
                    class="text-[10px] font-bold text-green-600 dark:text-green-500 bg-green-50 dark:bg-green-500/10 px-2 py-1 rounded-lg uppercase tracking-wider border border-green-100 dark:border-green-500/20">Linked</span>
                </div>

                <!-- Registration Date -->
                <div
                  class="w-full bg-slate-50 dark:bg-slate-800/40 p-5 rounded-2xl border border-slate-100 dark:border-slate-800 flex items-center gap-4 group transition-all hover:bg-white dark:hover:bg-slate-800 hover:shadow-sm">
                  <div
                    class="w-10 h-10 rounded-xl bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 flex items-center justify-center">
                    <span class="material-icons-outlined text-xl">event_available</span>
                  </div>
                  <div>
                    <label
                      class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest">วันที่สมัครสมาชิก</label>
                    <span class="text-sm font-black text-slate-800 dark:text-slate-200">
                      {{
                      memberProfile?.cityParkingUserProfileResponse
                      ?.createDate | date: "dd MMMMyyyy"
                      }}</span>
                  </div>
                </div>

                <!-- Language -->
                <div
                  class="w-full bg-slate-50 dark:bg-slate-800/40 p-5 rounded-2xl border border-slate-100 dark:border-slate-800 flex items-center gap-4 group transition-all hover:bg-white dark:hover:bg-slate-800 hover:shadow-sm">
                  <div
                    class="w-10 h-10 rounded-xl bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 flex items-center justify-center">
                    <span class="material-icons-outlined text-xl">language</span>
                  </div>
                  <div>
                    <label
                      class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest">ภาษาที่ใช้</label>
                    <span class="text-sm font-black text-slate-800 dark:text-slate-200 uppercase">{{
                      memberProfile?.cityParkingUserProfileResponse
                      ?.language || "th"
                      }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Tab: License Table -->
          <div *ngIf="activeTab === 'license'" class="animate-fade-in space-y-4">
            <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
              <h4
                class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest whitespace-nowrap">
                รายการทะเบียนรถ
              </h4>

              <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
                <!-- Search Input -->
                <div class="relative w-full sm:w-64">
                  <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <span class="material-icons-outlined text-slate-400 text-[18px]">search</span>
                  </div>
                  <input type="text" [(ngModel)]="searchVehicleText" placeholder="ค้นหาเลขทะเบียน..."
                    class="w-full h-10 pl-10 pr-4 rounded-xl text-sm bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-amber-400/50 focus:border-amber-400 transition-all" />
                </div>

                <button (click)="onCreateItem()"
                  class="cursor-pointer flex items-center justify-center gap-2 px-5 h-10 w-full sm:w-auto bg-gradient-to-r from-emerald-500 to-green-600 text-white rounded-xl hover:brightness-110 transition-all text-xs font-bold shadow-sm shadow-emerald-500/20 active:scale-95 whitespace-nowrap">
                  <span class="material-icons-outlined text-sm">add</span>
                  เพิ่มทะเบียนใหม่
                </button>
              </div>
            </div>

            <div
              class="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden shadow-sm">
              <div class="overflow-x-auto overflow-y-auto max-h-[350px] custom-scrollbar">
                <table class="w-full text-sm text-left relative">
                  <thead
                    class="bg-slate-50/80 dark:bg-slate-800/50 border-b border-slate-200 dark:border-slate-800 sticky top-0 z-10">
                    <tr>
                      <th
                        class="px-6 py-4 text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest w-16">
                        #
                      </th>
                      <th
                        class="px-6 py-4 text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest">
                        เลขทะเบียน / จังหวัด
                      </th>
                      <th
                        class="px-6 py-4 text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest">
                        ประเภทรถ
                      </th>
                      <th
                        class="px-6 py-4 text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest text-center">
                        ความเป็นเจ้าของ
                      </th>
                      <th
                        class="px-6 py-4 text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest text-center">
                        สถานะ
                      </th>
                      <th
                        class="px-6 py-4 text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest text-right">
                        ดำเนินการ
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-100 dark:divide-slate-800 bg-white dark:bg-slate-900">
                    <tr *ngFor="let plate of filteredVehicles; let i = index"
                      class="transition-colors duration-150 group"
                      [ngClass]="plate.isOwner
                        ? 'bg-emerald-50/40 hover:bg-emerald-50/70 dark:bg-emerald-950/10 dark:hover:bg-emerald-950/20'
                        : 'bg-amber-50/40 hover:bg-amber-50/70 dark:bg-amber-950/10 dark:hover:bg-amber-950/20'">
                      <td class="px-6 py-4 text-slate-400 font-bold text-xs">
                        {{ i + 1 }}
                      </td>
                      <td class="px-6 py-4 text-gray-900 dark:text-slate-100">
                        <div class="flex flex-col">
                          <span class="text-sm font-black">{{
                            plate.plateNumber
                            }}</span>
                          <span class="text-[10px] text-slate-500 dark:text-slate-400 font-medium">{{ plate.provinceName
                            }}</span>
                        </div>
                      </td>
                      <td class="px-6 py-4">
                        <span
                          class="px-3 py-1 bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 rounded-lg text-xs font-bold border border-slate-200 dark:border-slate-700">{{
                          plate.vehicleTypeName }}</span>
                      </td>
                      <td class="px-6 py-4 text-center">
                        <span
                          class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black whitespace-nowrap border"
                          [ngClass]="plate.isOwner
                            ? 'bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-400 dark:border-emerald-800'
                            : 'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/30 dark:text-amber-400 dark:border-amber-800'">
                          <span class="material-icons-outlined text-[14px]">{{
                            plate.isOwner ? 'verified_user' : 'link'
                          }}</span>
                          {{ plate.isOwner ? 'รถของสมาชิก' : 'รถที่เชื่อมโยง' }}
                        </span>
                      </td>
                      <td class="px-6 py-4 text-center">
                        <span
                          class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider"
                          [ngClass]="
                            plate.vehicleStatusId === 3
                              ? 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400'
                              : 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                          ">
                          <span class="w-1.5 h-1.5 rounded-full" [ngClass]="
                              plate.vehicleStatusId === 3
                                ? 'bg-rose-500'
                                : 'bg-emerald-500'
                            "></span>
                          {{
                          plate.vehicleStatusId === 3 ? "ปิดใช้งาน" : "ใช้งาน"
                          }}
                        </span>
                      </td>
                      <td class="px-6 py-4 text-right">
                        <div class="flex items-center justify-end gap-2">
                          <ng-container *ngIf="plate.canEdit; else readOnlyVehicle">
                          <button (click)="onEditItem(plate)"
                            class="w-8 h-8 flex items-center justify-center rounded-lg bg-slate-50 dark:bg-slate-800 text-slate-400 hover:text-amber-500 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-all"
                            title="แก้ไข">
                            <span class="material-icons-outlined text-[18px]">edit</span>
                          </button>
                          <button (click)="onDeleteItem(plate)"
                            class="w-8 h-8 flex items-center justify-center rounded-lg bg-slate-50 dark:bg-slate-800 text-slate-400 hover:text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 transition-all"
                            title="ลบ">
                            <span class="material-icons-outlined text-[18px]">delete</span>
                          </button>
                          </ng-container>
                          <ng-template #readOnlyVehicle>
                            <span
                              class="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-500 text-[10px] font-bold whitespace-nowrap"
                              title="ไม่มีสิทธิ์แก้ไขหรือลบรถคันนี้">
                              <span class="material-icons-outlined text-[14px]">lock</span>
                              ดูได้เท่านั้น
                            </span>
                          </ng-template>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="filteredVehicles.length === 0">
                      <td colspan="6" class="px-6 py-12 text-center bg-slate-50/30 dark:bg-slate-800/10">
                        <div class="flex flex-col items-center justify-center gap-3">
                          <span
                            class="material-icons-outlined text-4xl text-slate-300 dark:text-slate-600">no_sim</span>
                          <span class="text-sm font-bold text-slate-400">ไม่มีข้อมูลรถในระบบ</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Tab: Parking Cards Table -->
          <div *ngIf="activeTab === 'card'" class="animate-fade-in space-y-4">
            <div class="mb-2">
              <h4 class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest">
                รายการบัตรจอดรถ
              </h4>
            </div>

            <div
              class="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden shadow-sm">
              <div class="overflow-x-auto overflow-y-auto max-h-[350px] custom-scrollbar">
                <table class="w-full text-sm text-left relative">
                  <thead
                    class="bg-slate-50/80 dark:bg-slate-800/50 border-b border-slate-200 dark:border-slate-800 sticky top-0 z-10">
                    <tr>
                      <th
                        class="px-6 py-4 text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest w-16">
                        #
                      </th>
                      <th
                        class="px-6 py-4 text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest">
                        ประเภทบัตร / รหัส
                      </th>
                      <th
                        class="px-6 py-4 text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest">
                        ชื่อผู้ถือ
                      </th>
                      <!-- <th
                        class="px-6 py-4 text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest">
                        เลขทะเบียน
                      </th> -->
                      <th
                        class="px-6 py-4 text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest">
                        สถานที่ / Site
                      </th>
                      <th
                        class="px-6 py-4 text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest">
                        วันหมดอายุ
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-100 dark:divide-slate-800 bg-white dark:bg-slate-900">
                    <tr *ngFor="
                        let card of memberProfile?.parkingCardFromUserLineResponses;
                        let i = index
                      " class="hover:bg-slate-50/50 dark:hover:bg-slate-800/30 transition-colors duration-150">
                      <td class="px-6 py-4 text-slate-400 font-bold text-xs">
                        {{ i + 1 }}
                      </td>
                      <td class="px-6 py-4">
                        <div class="flex flex-col">
                          <span class="text-sm font-black text-amber-600 dark:text-amber-400">{{ card.cardName }}</span>
                        </div>
                      </td>
                      <td class="px-6 py-4 text-slate-700 dark:text-slate-300 font-bold text-xs">
                        {{ card.name }}
                      </td>
                      <!-- <td
                        class="px-6 py-4 text-slate-700 dark:text-slate-300 font-bold text-xs"
                      >
                        {{ card.licensePlate }}
                      </td> -->
                      <td class="px-6 py-4">
                        <span
                          class="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 text-[10px] font-bold uppercase tracking-wider border border-slate-200 dark:border-slate-700">
                          <span class="material-icons-outlined text-xs">location_on</span>
                          {{ card.siteName }}
                        </span>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div class="flex flex-col">
                          <span class="text-sm font-black text-slate-800 dark:text-slate-200">{{ card.expireDate | date:
                            "dd/MM/yyyy" }}</span>
                          <span
                            class="text-[9px] text-slate-400 dark:text-slate-500 font-bold uppercase tracking-widest">Valid
                            Thru</span>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="
                        (memberProfile?.parkingCardFromUserLineResponses || [])
                          .length === 0
                      ">
                      <td colspan="5" class="px-6 py-12 text-center bg-slate-50/30 dark:bg-slate-800/10">
                        <div class="flex flex-col items-center justify-center gap-3">
                          <span
                            class="material-icons-outlined text-4xl text-slate-300 dark:text-slate-600">credit_card_off</span>
                          <span class="text-sm font-bold text-slate-400">ไม่มีข้อมูลบัตรในระบบ</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div
      class="flex-none px-4 md:px-8 py-4 md:py-5 border-t border-slate-200/50 dark:border-slate-800/50 bg-slate-50/50 dark:bg-slate-900/50 flex flex-col-reverse md:flex-row justify-between gap-3 rounded-b-[24px]">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
        class="w-full md:w-auto px-5 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 rounded-xl transition-all shadow-sm border border-slate-200 dark:border-slate-700 inline-flex items-center justify-center gap-2 cursor-pointer">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex flex-col-reverse md:flex-row justify-end gap-3 ml-auto w-full md:w-auto">
      <button (click)="closeModal()"
        class="w-full md:w-auto px-6 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-800 rounded-xl transition-all shadow-sm border border-slate-200 dark:border-slate-700 cursor-pointer">
        ปิดหน้าต่าง
      </button>
      <button *ngIf="activeTab === 'info'" (click)="saveModal()" [disabled]="editingField"
        class="w-full md:w-auto px-8 py-2.5 text-sm font-bold text-white bg-gradient-to-r from-amber-500 to-yellow-500 hover:brightness-110 rounded-xl shadow-[0_8px_20px_-6px_rgba(250,204,21,0.5)] hover:shadow-[0_10px_25px_-6px_rgba(250,204,21,0.6)] hover:-translate-y-0.5 transition-all flex items-center justify-center gap-2 group disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none cursor-pointer">
        <span class="material-icons-outlined text-xl group-hover:scale-110 transition-transform">save</span>
        ยืนยันการบันทึก
      </button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal (Premium Match) -->
<div *ngIf="isDeleteModalOpen" class="fixed inset-0 z-[100] flex items-center justify-center p-4">
  <div class="absolute inset-0 bg-slate-950/60 backdrop-blur-md animate-fade-in" (click)="closeDeleteModal()"></div>
  <div
    class="relative bg-white dark:bg-slate-900 rounded-[32px] shadow-2xl w-full max-w-sm p-8 text-center animate-scale-up border border-white/20 dark:border-slate-800/50">
    <div
      class="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-rose-50 dark:bg-rose-900/30 mb-6 shadow-inner">
      <span class="material-icons-outlined text-4xl text-rose-500">delete_forever</span>
    </div>
    <h3 class="text-xl font-black text-slate-800 dark:text-white mb-2 tracking-tight">
      ยืนยันการลบข้อมูลรถ?
    </h3>
    <p class="text-sm text-slate-500 dark:text-slate-400 mb-8 leading-relaxed">
      คุณแน่ใจหรือไม่ที่จะลบรายการทะเบียนรถ
      <span
        class="font-black text-slate-800 dark:text-slate-200 bg-slate-100 dark:bg-slate-800 px-2 py-1 rounded-lg mx-1 uppercase">{{
        itemToDelete?.plateNumber }}</span>
      ใช่หรือไม่?<br />
      <span class="text-rose-500 font-bold mt-1 inline-block">* การกระทำนี้ไม่สามารถย้อนกลับได้</span>
    </p>
    <div class="grid grid-cols-2 gap-3">
      <button (click)="closeDeleteModal()"
        class="w-full py-3 text-sm font-bold text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-800 rounded-xl transition-all border border-slate-200 dark:border-slate-800">
        ยกเลิก
      </button>
      <button (click)="confirmDelete()"
        class="w-full py-3 bg-rose-600 hover:bg-rose-700 text-white rounded-xl text-sm font-bold shadow-lg shadow-rose-600/20 active:scale-95 transition-all">
        ลบข้อมูล
      </button>
    </div>
  </div>
</div>

<!-- Add/Edit Vehicle Modal Injection -->
<app-modal-line-oa-member-add-vehicle *ngIf="isAddVehicleModalOpen" [licenseOld]="selectedLicense"
  [member]="selectedMember" [eventForm]="eventForm" (close)="closeAddVehicleModal()">
</app-modal-line-oa-member-add-vehicle>

<!-- Picture preview lightbox -->
<div *ngIf="isPicturePreviewOpen && pictureUrl && !isPictureBroken"
  class="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-sm animate-fade-in"
  (click)="closePicturePreview()">
  <button type="button" (click)="closePicturePreview()"
    class="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors cursor-pointer"
    title="ปิด">
    <span class="material-icons">close</span>
  </button>
  <img [src]="pictureUrl"
    [alt]="memberProfile?.cityParkingUserProfileResponse?.fullName || 'LINE'"
    (click)="$event.stopPropagation()"
    class="max-w-[min(90vw,640px)] max-h-[85vh] rounded-2xl object-contain shadow-2xl border border-white/10" />
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && activityHistoryEntityId"
  [entityType]="activityEntityTypes.CpUser"
  [entityId]="activityHistoryEntityId"
  title="ประวัติสมาชิก City Parking"
  [subtitle]="'#' + activityHistoryEntityId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>